import { GetChannelParams } from 'src/interfaces/channel'
import HTTPRequest from '../index'

const apiPathChannel = 'api/v2/users/channel'

class Channel extends HTTPRequest {
  async getChannel(params: GetChannelParams) {
    const result = await this.get(`${apiPathChannel}`, { params })

    return result.data
  }
}

export default new Channel()
